import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { TextField, Button, Checkbox, Container, Dialog, DialogTitle, DialogContent, DialogActions, FormControlLabel, InputLabel, Select, MenuItem, Typography, Grid, Box, RadioGroup, Radio } from '@mui/material';
import Error from '../Error/Error';
import Success from '../Success/Success';
import { getUsername } from '../../context/AuthFunc';
import { useTranslation } from 'react-i18next';
import { addIngredient, getUnitsOfMeasure} from '../../api/axios';
import Ingredients from '../List/Ingredients';

const NewIngredient = () => {
    const { t } = useTranslation('global');

    const [name, setName] = useState('');
    const [unitOfMeasure, setUnitOfMeasure] = useState('');
    const [amount, setAmount] = useState(0);
    const [unitPrice, setUnitPrice] = useState(0);

    const [unitsOfMeasure, setUnitsOfMeasure] = useState([]);

    const [errMsg, setErrMsg] = useState('');
    const [succ, setSucc] = useState('');

    const [refreshKey, setRefreshKey] = useState(0);
    
    useEffect(()=>{
        const fetchUnitsOfMeasure = async () =>{
            const res = await getUnitsOfMeasure();
            setUnitsOfMeasure(res);
        }
        fetchUnitsOfMeasure();
    },)

    const handleSubmit = async (event) => {
        event.preventDefault();
        if(!name){
            setErrMsg(t("newOrganizationUnit.nameRequired"));
            return;
        }
        const newIngredient = {
            name,
            amount: parseFloat(amount),
            unit_of_measure_id: parseInt(unitOfMeasure),
            unit_price: parseFloat(unitPrice)
        };
        try{
            const response = await addIngredient(newIngredient);
            if(!response.success){
                setErrMsg(t("newTicket.somethingWentWrong"));
                setTimeout(() => setErrMsg(''), 3000);
            }
            else{
                
                setSucc(t("newTicket.successfullyAdded"));
                setName('');
                setUnitOfMeasure(0);
                setAmount(0);
                setUnitPrice(0);
                
                setTimeout(() => setSucc(''), 3000);
                setRefreshKey((prev) => prev + 1);
            }
        }
        catch (error) {
            setErrMsg(t("newTicket.failedToAddTicket"));
        }
    };

    return (
    <Container maxWidth="md" className="container-employee" sx={{ p: 3, flexShrink: 0 , mt: 4}} >
        <Typography variant="h4" sx={{ mb:4 }}>{t("ingredient.newIngredient")}</Typography>
            <form onSubmit={handleSubmit} style={{ display:"flex", justifyContent:"center", alignItems:"center"}}>
        <Grid container spacing={2}>
            <Grid item xs={12}>
                    <TextField
                        label={t("ingredient.name")}
                        fullWidth
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                    />
            </Grid>
            <Grid item xs={6}>
                <Grid item xs={12} sm={12}>
                    <Select
                        fullWidth
                        value={unitOfMeasure} // Koristi sektor kao vrednost
                        onChange={(e) => setUnitOfMeasure(e.target.value)} // Postavi samo ID selektovanog sketora
                        displayEmpty
                    >
                        <MenuItem value="" disabled>
                        {t("ingredient.unitOfMeasure")}
                        </MenuItem>
                        {unitsOfMeasure.map((unit) => (
                        <MenuItem key={unit.id} value={unit.id}>
                            {unit.name}
                        </MenuItem>
                        ))}
                    </Select>
                </Grid>
            </Grid>
            <Grid item xs={6}>
                <Grid item xs={12} sm={12}>
                    <TextField
                        label={t("ingredient.unitPrice")}
                        fullWidth
                        value={unitPrice}
                        onChange={(e) => setUnitPrice(e.target.value)}
                    />
                </Grid>
            </Grid>
            <Grid item xs={6}>
                <TextField
                        label={t("ingredient.amount")}
                        fullWidth
                        value={amount}
                        onChange={(e) => setAmount(e.target.value)}
                    />
            </Grid>
            <Grid item xs={12} sx={{ width:"100%", display:"flex", justifyContent:"flex-end"}}>
                <Button sx={{ width:"50%" }} variant="contained" type="submit">{t("newTicket.add")}</Button>
            </Grid>
        </Grid>
    </form>

    {errMsg && <Error message={errMsg} onClose={() => setErrMsg('')} />}
    {succ && <Success message={succ} onClose={() => setSucc('')} />}
        <Ingredients key={refreshKey}/>
    </Container>
    );
};

export default NewIngredient;
